import React from 'react';
export const QuoteBlock = ({
  who,
  children
}: {
  who: string;
  children: React.ReactNode;
}) => <div className="border-l-[3px] border-[#c8c0b0] bg-[#f7f5f0] p-[0.5rem_0.75rem] m-[0.6rem_0_0.8rem] rounded-r-[4px] text-[12.5px] text-[#666] italic" data-id="element-137">
    <div className="not-italic font-bold text-[11px] text-[#185FA5] mb-[0.2rem]" data-id="element-138">
      {who}
    </div>
    {children}
  </div>;